import { jwtDecode } from "jwt-decode";

export const AUTH_STATE_EVENT = "webcredai:auth-state-changed";

function emitAuthStateChange(isUserLoggedIn) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(AUTH_STATE_EVENT, {
      detail: { isUserLoggedIn },
    })
  );
}

export const hasStoredAuthTokens = () => {
  if (typeof window === "undefined") return false;
  return Boolean(
    localStorage.getItem("access_token") && localStorage.getItem("refresh_token")
  );
};

export const handleToken = async (data) => {
  // Save the tokens to local storage
  localStorage.setItem("access_token", data.access_token);
  localStorage.setItem("refresh_token", data.refresh_token);

  // Decode the JWT access token
  try {
    const base64Url = data.access_token.split(".")[1]; // Extract the payload
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/"); // Base64 format adjustments
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join("")
    );

    const decodedToken = JSON.parse(jsonPayload);

    // Assuming user_id is part of the payload
    if (decodedToken.user_id) {
      localStorage.setItem("user_id", decodedToken.user_id);
    } else {
      console.warn("user_id not found in the token payload.");
    }
  } catch (error) {
    console.error("Error decoding access token:", error);
  }

  emitAuthStateChange(true);
};

export const get_user_id = () => {
  return localStorage.getItem("user_id");
};

export const getRole = () => {
  try {
    const access_token = getAccessToken();
    const decodedToken = jwtDecode(access_token);
    const userRole = decodedToken.role;
    return userRole;
  } catch (error) {
    return "BASIC_USER";
  }
};
export const handleLogout = () => {
  const theme = localStorage.getItem("wc-theme");
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user_id");
  if (theme) {
    localStorage.setItem("wc-theme", theme);
  }
  emitAuthStateChange(false);
};
export const getAccessToken = () => {
  return localStorage.getItem("access_token");
};
const getRefreshToken = () => {
  return localStorage.getItem("refresh_token");
};

export const refreshAccessToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    handleLogout();
    return false;
  }

  try {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await fetch(`${apiUrl}/users/get_access`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${refreshToken}`,
      },
    });
    if (!response.ok) {
      handleLogout();
      return false;
    }
    const data = await response.json().catch(() => ({}));
    const tokens = data?.results;
    if (!tokens?.access_token || !tokens?.refresh_token) {
      handleLogout();
      return false;
    }
    handleToken(tokens);
    return true;
  } catch {
    handleLogout();
    return false;
  }
};

async function fetchCurrentUser(accessToken) {
  const apiUrl = process.env.REACT_APP_API_URL;
  return fetch(`${apiUrl}/users/get_current_user`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

export const verifyLogin = async () => {
  if (getAccessToken() && getRefreshToken()) {
    try {
      let response = await fetchCurrentUser(getAccessToken());
      if (!response.ok && response.status === 401) {
        const refreshed = await refreshAccessToken();
        if (!refreshed) {
          return false;
        }
        response = await fetchCurrentUser(getAccessToken());
      }
      if (!response.ok) {
        if (response.status === 401) handleLogout();
        return false;
      }
      const data = await response.json().catch(() => ({}));
      return Boolean(data?.results);
    } catch {
      return false;
    }
  }
  return false;
};
